import { createFormHook } from '@tanstack/react-form';

import { fieldContext, formContext } from './context';
import { FormProvider } from './provider';
import { defaultValues } from 'src/modules/Invitations/InvitationCreate/defaultValues';

export const { useAppForm, useTypedAppFormContext } = createFormHook({
  fieldComponents: {},
  fieldContext,
  formComponents: {
    FormProvider,
  },
  formContext,
});

/**
 * Options describing the wizard form, used purely to infer the fully-typed form
 * API for `useWizardForm`. `useTypedAppFormContext` never runs these at runtime
 * (it reads the live form from context), so they only need to mirror the shape
 * the owner (`InvitationCreate`) creates the form with. `defaultValues` is what
 * fixes the value type to `InvitationCreateFormValues`.
 *
 * This intentionally does not import `wizardConfig`/the step schemas: doing so
 * would create an import cycle (form -> wizardConfig -> step components ->
 * form), so we consume the cycle-free `defaultValues` from `types` instead.
 */
const wizardFormInferenceOptions = {
  defaultValues,
};

/**
 * Typed accessor for the wizard form context. Step components read the shared
 * form instance through this hook so field names and values stay type-checked
 * against `InvitationCreateFormValues`.
 */
export const useWizardForm = () =>
  useTypedAppFormContext(wizardFormInferenceOptions);

export * from './context';
